import { ROUTE_BACK, ROUTE_REPLACE, ROUTE_TO, cacheView, setView } from "../actions/ui";

export const ui = {

  [ROUTE_TO]: async ({ api, dispatch, getState, action }) => {
    dispatch(cacheView(getState().ui.currentView))
    try {
      window.history.pushState({ view: action.payload.view, payload: action.payload.payload, tab: action.payload.tab }, null);
    } catch (e) {}
    dispatch(setView(action.payload));
  },

  [ROUTE_REPLACE]: async ({ api, dispatch, getState, action }) => {
    try {
      window.history.replaceState({ view: action.payload.view, payload: action.payload.payload, tab: action.payload.tab }, null);
    } catch (e) {}
    dispatch(setView(action.payload));
  },

  [ROUTE_BACK]: async ({ api, dispatch, getState, action }) => {
    window.history.back();
  },

}